import React, { useState, useEffect } from "react";
import { Typography, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Box } from "@mui/material";
import { getCheckInOutData, getBallkids } from "../firebaseService";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import { useTournamentConfig } from "../context/TournamentConfigContext";
import { useGroup } from "../context/GroupContext";

const AttendanceReport = () => {
  const { daysOfWeek } = useTournamentConfig();
  const { activeGroup } = useGroup();
  const memberLabel = activeGroup?.memberLabel || "Mitglieder";
  const [attendanceData, setAttendanceData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const ballkids = await getBallkids();
      const checkInOutData = await getCheckInOutData();

      const processedData = ballkids.map((bk) => {
        const attendanceByDay = daysOfWeek.map((day) => {
          const record = checkInOutData.find((entry) => entry.ballkidId === bk.id && entry.day === day);
          if (record?.checkIn && record?.checkOut) {
            const checkInTime = new Date(record.checkIn);
            const checkOutTime = new Date(record.checkOut);
            return ((checkOutTime - checkInTime) / (1000 * 60 * 60)).toFixed(2); // Hours calculation
          }
          return "0";
        });
        return { name: bk.name, attendanceByDay };
      });
      const sortedData = processedData.sort((a, b) => a.name.localeCompare(b.name));

      setAttendanceData(sortedData  );
    };
    fetchData();
  }, []);

  const exportToCSV = () => {
    const csvData = [
      ["Name", ...daysOfWeek],
      ...attendanceData.map((row) => [row.name, ...row.attendanceByDay]),
    ];
    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `${memberLabel}_anwesenheit.csv`);
  };

  return (
    <Box>
    <Typography variant="h5" sx={{ textAlign: "center", mb: 2 }}>
    {memberLabel} Anwesenheitsbericht      </Typography>
      <Button variant="contained" color="primary" onClick={exportToCSV} style={{ marginBottom: 20 }}>
        Export als CSV
      </Button>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              {daysOfWeek.map((day, index) => (
                <TableCell key={index} align="center">{day}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {attendanceData.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.name}</TableCell>
                {row.attendanceByDay.map((hours, idx) => (
                  <TableCell key={idx} align="center">{hours} h</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AttendanceReport;